var React = require('react');

function Raitaru (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".cls-1{fill:none;stroke:#000;stroke-linecap:square;stroke-linejoin:bevel;stroke-width:2px;}")),React.createElement("title",{"key":1},"Raitaru"),React.createElement("g",{"id":"g1483","key":2},[React.createElement("path",{"id":"path1618-3-5-6","className":"cls-1","d":"M94,39H34V89H94Z","key":0}),React.createElement("path",{"id":"path1652-6-9-9-8","className":"cls-1","d":"M64,119V89","key":1}),React.createElement("path",{"id":"path1652-6-9-9","className":"cls-1","d":"M64,39V9","key":2})])]);
}

Raitaru.defaultProps = {"id":"svg8","viewBox":"0 0 128 128"};

module.exports = Raitaru;

Raitaru.default = Raitaru;
